export const FUND_COLORS = {
  "Schonfeld Strategic Partners Fund LLC": "#FF8C00",
  "Verition Fund LLC": "#708090",
  "Balyasny Asset Management": "#228B22",
  "AQR L/S (50% Net)": "#B8860B",
  "AQR Apex Strategy": "#8B4513",
  "Point72": "#9370DB",
  "SPX Index": "#DC143C",
  "Marshall Wace": "#FFD700",
  "LMR": "#8B0000",
  "CFM": "#006400",
  "Millennium": "#FF69B4",
  "Walleye": "#4169E1",
  "Citadel": "#2F4F4F",
  "Two Sigma (Spectra)": "#FF4500",
  "BlackRock": "#800080",
};

const EXTRA = [
  "#e6194b", "#3cb44b", "#4363d8", "#f58231", "#911eb4",
  "#42d4f4", "#f032e6", "#bfef45", "#fabed4", "#469990",
];

export const getFundColor = (name, colorMap) => {
  if (colorMap && colorMap[name]) return colorMap[name];
  if (FUND_COLORS[name]) return FUND_COLORS[name];
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash << 5) - hash + name.charCodeAt(i);
  return EXTRA[Math.abs(hash) % EXTRA.length];
};
